import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram, faLinkedinIn, faTiktok, faXTwitter } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';

interface LayoutProps {
  children: React.ReactNode;
  isHomePage?: boolean;
}

const Layout: React.FC<LayoutProps> = ({ children, isHomePage }) => {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrollPosition, setScrollPosition] = useState(0);
  
  const menuItems = [
    { path: "/", label: "noprblm." },
    { path: "/archive", label: "archive" }
  ];

  useEffect(() => {
    const handleScroll = () => {
      setScrollPosition(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  
  useEffect(() => {
    return () => {
      document.body.style.overflow = '';
    };
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    
    if (!isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  };

  return (
    <div className="site-container">
      <header className={`site-header ${scrollPosition > 50 ? 'header-scrolled' : ''}`}>
        <div className="header-inner">
          <button 
            className={`menu-toggle ${isMenuOpen ? 'menu-open' : ''}`} 
            onClick={toggleMenu} 
            aria-label="Toggle menu"
          >
            <span className="menu-line"></span>
            <span className="menu-line"></span>
          </button>
        </div>
      </header>

      <div className={`menu-overlay ${isMenuOpen ? 'menu-visible' : ''}`}>
        <nav className="site-nav">
          <ul className="menu-list">
            {menuItems.map((item) => (
              <li key={item.path} className={location.pathname === item.path ? 'active' : ''}>
                <Link 
                  to={item.path}
                  onClick={() => setIsMenuOpen(false)}
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      </div>
      
      <main className="site-main">
        {children}
      </main>
      
      <footer className="site-footer">
        <div className="footer-inner">
          <div className="footer-content">
            <div className="social-links">
              <a href="mailto:info@noprblm.com" className="social-icon" aria-label="Email">
                <FontAwesomeIcon icon={faEnvelope} />
              </a>
              <a href="https://x.com/itssnoprblm" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="X (Twitter)">
                <FontAwesomeIcon icon={faXTwitter} />
              </a>
              <a href="https://www.tiktok.com/@itsnoprblm" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="TikTok">
                <FontAwesomeIcon icon={faTiktok} />
              </a>
              <a href="https://www.instagram.com/itsnoprblm/" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Instagram">
                <FontAwesomeIcon icon={faInstagram} />
              </a>
              <a href="https://www.linkedin.com/company/noprblm/?viewAsMember=true" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="LinkedIn">
                <FontAwesomeIcon icon={faLinkedinIn} />
              </a>
            </div>
            <span className="copyright">London | Los Angeles | Korea</span>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Layout;